import { connect } from 'react-redux'
import { getCheckoutRedirection } from 'store/selectors'

const mapStateToProps = state => ({
  checkoutRedirection: getCheckoutRedirection(state)
})

export default connect(mapStateToProps)
